import { render } from "./NieuwsView.vue?vue&type=template&id=69f0dde4"
import script from "./NieuwsView.vue?vue&type=script&lang=js"
export * from "./NieuwsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__